/* eslint-disable multiline-ternary */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip
} from '@mui/material'
import FlowSheetForm from '@shared/flowsheet-form/FlowSheetForm'
import TopSection from '@shared/top-section/TopSection'
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './Questionnaire.module.scss'
import { CurrentOrganizationContext } from '@context/CurrentOrganization'
import ClinicvuService from 'services/Clinicvu/Clinicvu.service'

const FlowSheet = () => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [allFlowSheets, setAllFlowSheets] = useState([])
  const [flowSheets, setFlowSheets] = useState([])
  const [showNew, setShowNew] = useState(false)
  const [selectedFlowSheet, setSelectedFlowSheet] = useState(null)

  const { currentOrganization } = useContext(CurrentOrganizationContext)
  const location = useLocation()
  const navigate = useNavigate()

  const fetchFlowSheets = async () => {
    if (currentOrganization) {
      try {
        const res = await ClinicvuService.getAllFlowSheets(currentOrganization)
        setAllFlowSheets(res.data)
        setPage(0)
      } catch (e) {
        console.error(
          `Error occurred while fetching flow sheets on portal: ${e}`
        )
      }
    }
  }

  useEffect(() => {
    fetchFlowSheets()
  }, [currentOrganization])

  useEffect(() => {
    setFlowSheets(allFlowSheets.slice(0, rowsPerPage))
  }, [allFlowSheets, rowsPerPage])

  useEffect(() => {
    toggleEditOrNew(null, false)
  }, [location.key])

  const handlePageChange = (e, newPage) => {
    setPage(newPage)
    setFlowSheets(
      allFlowSheets.slice(
        newPage * rowsPerPage,
        newPage * rowsPerPage + rowsPerPage
      )
    )
  }

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10)
    setRowsPerPage(newRowsPerPage)
    setPage(0)
    setFlowSheets(allFlowSheets.slice(0, newRowsPerPage))
  }

  // eslint-disable-next-line no-unused-vars
  const deleteFlowSheet = async (name) => {
    if (currentOrganization) {
      try {
        await ClinicvuService.deleteSurvey(currentOrganization, name)
        console.log(`Flow Sheet ${name} was deleted .`)
      } catch (e) {
        console.error(
          `Error occurred while deleting flow sheet with the name: ${name}`
        )
      }
    }
  }

  const toggleEditOrNew = (flowSheet, toggle) => {
    setSelectedFlowSheet(flowSheet)
    setShowNew(toggle)
  }

  const handleFlowSheetClick = (flowSheet) => {
    navigate(`/flow-sheets/${flowSheet.id}`) // Navigate to the desired route
  }

  return (
    <div className={styles.content}>
      <TopSection btnFunction={toggleEditOrNew} showNew={showNew}></TopSection>
      {!showNew ? (
        <div>
          <div className={styles.container}>
            <TableContainer component={Paper}>
              <Table aria-label="Flow Sheets Table" className={styles.table}>
                <TableHead className={styles.table__head}>
                  <TableRow>
                    <TableCell width="90%">Name</TableCell>
                    <TableCell width="5%"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {flowSheets.map((flowSheet, index) => (
                    <TableRow
                      className={styles.tablerow}
                      key={index}
                      onClick={() => handleFlowSheetClick(flowSheet)}
                    >
                      <TableCell>{flowSheet.title}</TableCell>
                      <TableCell>
                        <div className={styles.buttons}>
                          <Tooltip title="View Questionnaire">
                            <button className={styles.buttons__btn}>
                              <img src="/assets/svgs/pencil.svg" alt="Edit" />
                            </button>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleRowsPerPageChange}
                      page={page}
                      onPageChange={handlePageChange}
                      count={allFlowSheets.length}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </div>
        </div>
      ) : (
        <div>
          <FlowSheetForm
            btnFunction={toggleEditOrNew}
            survey={selectedFlowSheet}
            portal={currentOrganization}
            fetchAction={fetchFlowSheets}
          />
        </div>
      )}
    </div>
  )
}

export default FlowSheet
